module.exports = __webpack_public_path__ + "img/hk_product_global@2x.c0046f13.png";